import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGallery, IGalleryInitialState } from "./galleryModal";
import {
  ActiveInactiveGallery,
  // GalleryImageUpload,
  createGallery,
  deleteGallery,
  getAllActiveGallerys,
  getAllGallerys,
  getGalleryByID,
  updateGallery,
} from "./services/gallery.services";

const initialState: IGalleryInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  GalleryID: null,
  GalleryList: [],
  GalleryDetail: {
    ImgAlt: "",
    GalleryImage: "",
    ImageType: "",
    IsshowHome: false,
    IsActive: 1,
  },
};

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {
    clearGalleryDetails: (state) => {
      state.GalleryDetail = initialState.GalleryDetail;
    },
    setGalleryID: (state, action) => {
      state.GalleryID = action.payload;
    },
    clearGalleryID: (state) => {
      state.GalleryID = initialState.GalleryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllGallerys.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllGallerys.fulfilled,
      (state, action: PayloadAction<IGallery[]>) => {
        state.loading = false;
        state.GalleryList = action.payload || [];
      },
    );
    builder.addCase(getAllGallerys.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GalleryList = [];
    });
    builder.addCase(createGallery.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createGallery.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createGallery.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateGallery.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateGallery.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateGallery.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteGallery.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteGallery.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGallery.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getGalleryByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getGalleryByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.GalleryDetail = action.payload;
    });
    builder.addCase(getGalleryByID.rejected, (state, action) => {
      state.formLoading = false;
      state.GalleryDetail = initialState.GalleryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveGallerys.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveGallerys.fulfilled,
      (state, action: PayloadAction<IGallery[]>) => {
        state.loading = false;
        state.GalleryList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveGallerys.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GalleryList = [];
    });
    builder.addCase(ActiveInactiveGallery.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveGallery.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveGallery.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    // builder.addCase(GalleryImageUpload.pending, (state) => {
    //   state.loading = true;
    //   state.error = "";
    // });
    // builder.addCase(GalleryImageUpload.fulfilled, (state) => {
    //   state.loading = false;
    // });
    // builder.addCase(GalleryImageUpload.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Something went wrong";
    // });
  },
});

export const { clearGalleryDetails, clearGalleryID, setGalleryID } =
  gallerySlice.actions;
export default gallerySlice.reducer;
